import { http } from "./client";
import type { EffectiveFeature, ModuleDefinition } from "@/types/domain";

// Tenant-only Feature Toggle Management - there is no global/platform-wide
// endpoint here at all. See types/domain.ts's note on why.
export const featuresApi = {
  // ---- workspace self-service - any authenticated tenant member ----
  my: () => http.get<EffectiveFeature[]>("/features/my"),

  // ---- the fixed module catalog - Super Admin only ----
  modules: () => http.get<ModuleDefinition[]>("/features"),

  // ---- per-tenant toggles - Super Admin only ----
  tenantFeatures: (tenantId: string) => http.get<EffectiveFeature[]>(`/tenants/${tenantId}/features`),
  setForTenant: (tenantId: string, moduleKey: string, enabled: boolean) =>
    http.put<EffectiveFeature>(`/tenants/${tenantId}/features/${moduleKey}`, { enabled }),
  revertForTenant: (tenantId: string, moduleKey: string) =>
    http.delete<{ reverted: boolean }>(`/tenants/${tenantId}/features/${moduleKey}`),
  bulkSetForTenant: (tenantId: string, updates: Record<string, boolean>) =>
    http.put<EffectiveFeature[]>(`/tenants/${tenantId}/features`, { updates }),
  resetForTenant: (tenantId: string) =>
    http.delete<{ reset: boolean; toggles_cleared: number }>(`/tenants/${tenantId}/features`),
};
